import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import Select from "react-select";
import "../../assets/css/stepper.css";
import {
  getUserList,
  addDepartmentUser,
  getDefaultUserList,
} from "../../services/Users-services";
import { addUserToGroup } from "../../services/Users-services";
import { getOrganizationLevel } from "../../services/OrganisationServices/organizationLevel";
import {
  callToast,
  showErrorMessages,
} from "../../services/utilityFunctions.js";
import {
  getCountryList,
  getCityList,
  getStateList,
} from "../../services/system.js";
import { useGlobalState } from "../../services/hostelConst";
import { getLocalStorageData } from "../../services/axiosComponent";
import RegexPatterns from "../../services/regex";

const AddDepartmentUser = (props) => {
  const refresh = props.refresh;

  const { closeModal, modalState } = useGlobalState();
  console.log(modalState.data, "modalState");
  let navigate = props.navigate;
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    // Site Info

    userId: { value: "", label: "", regionId: "", siteId: "" },
    levelId: { value: "", label: "" },
  });

  const [loadingUserOptions, setLoadingUserOptions] = useState(false);
  const [loadingDepartmentLevelOptions, setLoadingDepartmentLevelOptions] =
    useState(false);

  const [userOptions, setUserOptions] = useState([]);
  const [departmentLevelOptions, setDepartmentLevelOptions] = useState([]);

  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const getOrganizationLevelOptions = async (inputValue = null) => {
    setLoadingDepartmentLevelOptions(true);
    const res = await getOrganizationLevel({
      query: inputValue,
      type: "DEPARTMENT",
      organizationId:
        getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
    });
    if (res.status == "success") {
      var list = [];
      console.log(res, "res");
      res.data.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
        });
      });
      setDepartmentLevelOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingDepartmentLevelOptions(false);
  };

  const getUserOptions = async (managerName = null) => {
    setLoadingUserOptions(true);
    const res = await getDefaultUserList({
      query: managerName,
      type: "DEPARTMENT",
      entityId: modalState?.data["_ID"],
      regionId: modalState?.data["_REGION"],
      siteId: modalState?.data["_SITE"],
      status: "Y",
    });
    if (res.status == "success") {
      console.log("called");
      var list = [];
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
          regionId: item["_REGION"],
          siteId: item["_SITE"],
        });
      });

      setUserOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingUserOptions(false);
  };
  useEffect(() => {
    getUserOptions();
    getOrganizationLevelOptions();

    return () => {};
  }, []);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    setErrors({ ...errors, [field]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.userId || !formData.userId.value) {
      newErrors.userId = "User is required";
    }
    if (!formData.levelId || !formData.levelId.value) {
      newErrors.levelId = "Level is required";
    }

    // Step 2 validation

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      console.log(modalState.id, "from Props");
      var data = {
        departmentId: modalState.id,

        departmentLevelId: formData.levelId.value,
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
        regionId: formData.userId.regionId,
        siteId: formData.userId.siteId,
        userId: formData.userId.value,
      };

      var res = await addDepartmentUser(data);
      if (res.status == "success") {
        callToast("success", "Success", "User Added  Successfully");
        await refresh();
        closeModal();
      } else {
        closeModal();
        showErrorMessages({ data: res, navigate });
      }
      setLoading(false);
    }
  };

  return (
    <>
      <section className="">
        <div className="d-flex  justify-content-center ">
          <div className="w-100 m-3">
            <div className="d-flex h-100">
              <div className="w-100">
                <>
                  <div className="stepper mb-3 ">
                    <div className="d-flex justify-content-between">
                      <div className={`step active`}>User Info</div>
                    </div>
                  </div>

                  {
                    // Step 1: Site Info
                    <>
                      <div className="row mb-3 m-4 me-2 ms-2">
                        <div className="col-md-12">
                          <label className="form-label">User</label>
                          <Select
                            options={userOptions}
                            value={
                              formData.userId.label === ""
                                ? null
                                : formData.userId
                            }
                            onChange={(value) =>
                              handleChange(
                                "userId",
                                value == null
                                  ? {
                                      value: "",
                                      label: "",
                                      regionId: "",
                                      siteId: "",
                                    }
                                  : value
                              )
                            }
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                height: "100px", // Set dropdown height
                              }),
                              menuList: (provided) => ({
                                ...provided,
                                maxHeight: "100px", // Set max height for the list
                                overflowY: "auto",
                              }),
                            }}
                            placeholder="Select User"
                            isSearchable
                            onInputChange={(inputValue) => {
                              if (inputValue.length > 1) {
                                getUserOptions(inputValue);
                              }
                            }}
                            noOptionsMessage={() => {
                              return "No User Found";
                            }}
                            components={
                              loadingUserOptions
                                ? {
                                    DropdownIndicator,
                                  }
                                : null
                            }
                            className="basic-single"
                            classNamePrefix="select"
                            filterOption={(option, inputValue) =>
                              option.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                          />
                          {errors.userId && (
                            <small className="text-danger">
                              {errors.userId}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="row mb-3 m-4 me-2 ms-2">
                        <div className="col-md-12">
                          <label className="form-label">Level</label>
                          <Select
                            options={departmentLevelOptions}
                            value={
                              formData.levelId.label === ""
                                ? null
                                : formData.levelId
                            }
                            onChange={(value) =>
                              handleChange(
                                "levelId",
                                value == null ? { value: "", label: "" } : value
                              )
                            }
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                height: "100px", // Set dropdown height
                              }),
                              menuList: (provided) => ({
                                ...provided,
                                maxHeight: "100px", // Set max height for the list
                                overflowY: "auto",
                              }),
                            }}
                            placeholder="Select Level"
                            isSearchable
                            onInputChange={(inputValue) => {
                              if (inputValue.length > 0) {
                                getOrganizationLevelOptions(inputValue);
                              }
                            }}
                            noOptionsMessage={() => {
                              return "No Level Found";
                            }}
                            components={
                              loadingDepartmentLevelOptions
                                ? {
                                    DropdownIndicator,
                                  }
                                : null
                            }
                            className="basic-single"
                            classNamePrefix="select"
                            filterOption={(option, inputValue) =>
                              option.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                          />
                          {errors.levelId && (
                            <small className="text-danger">
                              {errors.levelId}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-end m-3 mb-0">
                        <Button
                          type="submit"
                          disabled={loading}
                          onClick={handleSubmit}
                        >
                          {loading ? (
                            <div
                              class="spinner-border text-light"
                              role="status"
                            >
                       
                            </div>
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    </>
                  }
                </>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddDepartmentUser;
